var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "div",
        [
          _c(
            "v-alert",
            {
              attrs: {
                color: "error",
                icon: "warning",
                dismissible: "",
                outline: ""
              },
              model: {
                value: _vm.alert,
                callback: function($$v) {
                  _vm.alert = $$v
                },
                expression: "alert"
              }
            },
            [
              _vm._v(
                "\n     Your transaction has been canceled. Your account has not been charged.\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-alert",
            {
              attrs: {
                color: "success",
                icon: "check_circle",
                dismissible: "",
                outline: ""
              },
              model: {
                value: _vm.alert2,
                callback: function($$v) {
                  _vm.alert2 = $$v
                },
                expression: "alert2"
              }
            },
            [_vm._v("\n     Success! Your Account has been updated.\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        { staticClass: "body" },
        [
          _c("v-layout", { staticClass: "titles", attrs: { column: "" } }, [
            _c("h2", { staticClass: "title-1" }, [_vm._v("Get More Credits")])
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "plan", attrs: { xs12: "", md6: "", lg3: "" } },
                [
                  _c("p", { staticClass: "text-1", attrs: { mb2: "" } }, [
                    _vm._v(
                      _vm._s(_vm.plans[0].title) +
                        ": " +
                        _vm._s(_vm.plans[0].price)
                    ),
                    _c("br"),
                    _vm._v(_vm._s(_vm.plans[0].credit))
                  ]),
                  _vm._v(" "),
                  _c("PayPal", {
                    staticClass: "paypal_btn",
                    staticStyle: { "z-index": "0" },
                    attrs: {
                      env: "production",
                      amount: "5.00",
                      currency: "USD",
                      "button-style": _vm.myStyle,
                      client: _vm.credentials,
                      braintree: _vm.braintreeSdk,
                      experience: _vm.experienceOptions
                    },
                    on: {
                      "payment-authorized": _vm.paymentAuthorized,
                      "payment-completed": _vm.paymentCompleted,
                      "payment-cancelled": _vm.paymentCancelled
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "plan", attrs: { xs12: "", md6: "", lg3: "" } },
                [
                  _c("p", { staticClass: "text-1", attrs: { mb2: "" } }, [
                    _vm._v(
                      _vm._s(_vm.plans[1].title) +
                        ": " +
                        _vm._s(_vm.plans[1].price)
                    ),
                    _c("br"),
                    _vm._v(_vm._s(_vm.plans[1].credit))
                  ]),
                  _vm._v(" "),
                  _c("PayPal", {
                    staticClass: "paypal_btn",
                    attrs: {
                      env: "production",
                      amount: "10.00",
                      currency: "USD",
                      "button-style": _vm.myStyle,
                      client: _vm.credentials,
                      braintree: _vm.braintreeSdk,
                      experience: _vm.experienceOptions
                    },
                    on: {
                      "payment-authorized": _vm.paymentAuthorized,
                      "payment-completed": _vm.paymentCompleted,
                      "payment-cancelled": _vm.paymentCancelled
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "plan", attrs: { xs12: "", md6: "", lg3: "" } },
                [
                  _c("p", { staticClass: "text-1", attrs: { mb2: "" } }, [
                    _vm._v(
                      _vm._s(_vm.plans[2].title) +
                        ": " +
                        _vm._s(_vm.plans[2].price)
                    ),
                    _c("br"),
                    _vm._v(_vm._s(_vm.plans[2].credit))
                  ]),
                  _vm._v(" "),
                  _c("PayPal", {
                    staticClass: "paypal_btn",
                    attrs: {
                      env: "production",
                      amount: "20.00",
                      currency: "USD",
                      "button-style": _vm.myStyle,
                      client: _vm.credentials,
                      braintree: _vm.braintreeSdk,
                      experience: _vm.experienceOptions
                    },
                    on: {
                      "payment-authorized": _vm.paymentAuthorized,
                      "payment-completed": _vm.paymentCompleted,
                      "payment-cancelled": _vm.paymentCancelled
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "text-2", attrs: { column: "" } },
            [
              _c("h2", { staticClass: "title-2" }, [
                _c("strong", [_vm._v("Why use premium credits?")])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-1" }, [
                _vm._v(
                  "\n          Premium credits help to ensure that blogs actually listen to and respond to submissions in a timely\n          manner."
                ),
                _c("br"),
                _vm._v("\n          Here are some of their benefits:"),
                _c("br")
              ]),
              _vm._v(" "),
              _vm._l(_vm.texts, function(text, index) {
                return _c("v-flex", [
                  _c("strong", [_vm._v(_vm._s(index + 1) + ".")]),
                  _vm._v(" " + _vm._s(text)),
                  _c("br")
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "text-2", attrs: { column: "" } },
            [
              _c("v-flex", [
                _c("p", { staticClass: "text-1" }, [
                  _vm._v(
                    "\n            * If the above conditions are not met after 48 hours, you get your credit back!"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            ** Premium credits are roughly US$1 each, with discounts if you buy more. For example, you can use five\n            credits to send\n            one song to five bloggers."
                  ),
                  _c("br")
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b62316a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b62316a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/account2.vue
// module id = null
// module chunks = 